
export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Agenda',
      description: 'Completa nuestro formulario y selecciona la fecha que mejor te convenga. Te confirmaremos tu cita en menos de 24 horas.',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '02',
      title: 'Limpiamos',
      description: 'Nuestro equipo profesional llega puntualmente con todos los productos y equipos necesarios para dejar tu espacio impecable.',
      icon: 'ri-brush-2-line'
    },
    {
      number: '03',
      title: 'Disfruta',
      description: 'Relájate y disfruta de tu espacio limpio y fresco. Si no estás 100% satisfecho, regresamos sin costo adicional.',
      icon: 'ri-emotion-happy-line'
    }
  ];

  return (
    <section id="proceso" className="py-20 bg-gradient-to-br from-slate-50 to-sky-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-outfit">
            Proceso Simple
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto font-inter">
            En solo tres pasos sencillos, transformamos tu espacio en un lugar impecable
          </p>
        </div>

        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-sky-200 via-sky-300 to-emerald-200 transform -translate-y-1/2 z-0"></div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 relative z-10">
            {steps.map((step, index) => (
              <div key={index} className="text-center">
                <div className="relative mb-8">
                  {/* Step Circle */}
                  <div className="w-20 h-20 bg-white border-4 border-sky-200 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                    <i className={`${step.icon} text-sky-500 text-2xl`}></i>
                  </div>
                  
                  {/* Step Number */}
                  <div className="absolute -top-2 -right-2 w-8 h-8 bg-emerald-500 text-white rounded-full flex items-center justify-center text-sm font-bold">
                    {step.number}
                  </div>
                </div>
                
                <h3 className="text-2xl font-semibold text-slate-900 mb-4 font-outfit">
                  {step.title}
                </h3>
                
                <p className="text-slate-600 leading-relaxed font-inter">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
